import React from 'react'
import { HiArrowNarrowRight } from 'react-icons/hi'
import {Link} from 'react-scroll'

const Home = () => {
  return (
    <div name='home' className='w-full h-screen bg-[#0a192f]'>
        {/* Container */}
        <div className='max-w-[1000px] h-full mx-auto flex flex-col justify-center px-8'>
            <p className='text-[#ff914d]'>Hi, My name is</p>
            <h1 className='text-4xl sm:text-7xl font-bold text-[#ccd6f6]'>Rifadh Rijan</h1>
            <h2 className='text-4xl sm:text-7xl font-bold text-[#8892b0] '>I'm a Full Stack Developer</h2>
            <p className='text-[#8892b0] py-4 max-w-[700px]'>
            I'm an undergraduate from SLIIT and passionate developer, focused on building responsive full-stack web applications. Enhancing my skills on both front-end and back-end technologies.
            </p>
            <div>
            <Link to='projects' smooth={true} duration={500}>
                <button className='text-white border-2 px-6 py-3 my-2 flex items-center gap-3 hover:bg-[#ff914d] hover:border-[#ff914d]'>View Projects <HiArrowNarrowRight /></button>
            </Link>
            </div>
        </div>
      
    </div>
  )
}

export default Home
